// ----------------------------------------------------
// src/Redux/Slices/RouteSlice.js
// ----------------------------------------------------

import { createSlice } from "@reduxjs/toolkit";
import HeaderData from "../../Json/Header.json";

const RouteSlice = createSlice({
  name: "routes",
  initialState: HeaderData,
  reducers: {}
});

export default RouteSlice.reducer;